import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../icon'

const ProjectBanner = ({name, tag, imgUrl, projectUrl, className}) => {

  const description = (
    <div className="project-banner--text">
      <h2 className="h3">{name}</h2>
      <h3 className="p">{tag}</h3>
    </div>
  )

  if (projectUrl === undefined || imgUrl === undefined) {
    return ( 
      <li className="project-banner"> 
          <div className="project-banner--background">
            <div className="project-banner--coming-soon">
              coming soon
            </div>
          </div>
          {description}
      </li>
    )
  }

  const image = {
    backgroundImage: `url(${imgUrl})`
  }
  
  return (
    <li className="project-banner">
      <Link to={projectUrl}> 
        <div className="project-banner--image" style={image}/>
        {description}
      </Link>
    </li>
  )

}

export default ProjectBanner;


// WEBPACK FOOTER //
// ./components/page-project-list/project-banner.js